import React, { useState } from 'react'
import IconButton from '../../../molecules/iconbutton/IconButton'
import ReportingTemplatePreviewModal from '../ReportingTemplatePreviewModal'

interface Props {
  reportingTemplateId: string
}

export const GenericPreview: React.FC<Props> = ({ reportingTemplateId }) => {
  const [showModal, setShowModal] = useState(false)
  return (<>
    <IconButton
      icon='preview'
      text='Preview'
      onClick={() => { setShowModal(true) }}
    />
    <ReportingTemplatePreviewModal
      isOpen={showModal}
      onClose={() => setShowModal(false)}
      reportingTemplateId={reportingTemplateId}
      showSimulationDropdown
    />
  </>)
}


